<template>
  <div class="nav">
    <!-- Logo 区域 -->
    <div class="logo">
      <router-link to="/">
        <img class="logo-img" src="../assets/logo.png" />
      </router-link>
    </div>

    <!-- 手机端汉堡按钮（仅在移动端显示） -->
    <div
      class="mobile-toggle"
      @click="toggleMenu"
      :class="{ 'is-active': isMenuOpen }"
    >
      <span class="line"></span>
      <span class="line"></span>
      <span class="line"></span>
    </div>

    <!-- 导航菜单区域（PC正常显示，手机端根据 isMenuOpen 控制展开收起） -->
    <div class="menu" :class="{ 'mobile-show': isMenuOpen }">
      <ul class="nav_ul">
        <li @click="closeMenu"><router-link to="/home">首页</router-link></li>

        <!-- 主营业务：带下拉/折叠菜单 -->
        <li class="ddd" :class="{ 'mobile-expanded': isSubMenuOpen }">
          <!-- PC端支持 hover 跳转，手机端首次点击用于展开子菜单 -->
          <a
            href="javascript:;"
            class="menu-title"
            @click.stop="handleBusinessClick"
          >
            主营业务
            <i class="arrow-icon"></i>
          </a>
          <div class="dropdown_content">
            <div class="divsss">
              <p @click="closeMenu">
                <router-link to="/industry/gonglu">公路运输</router-link>
              </p>
              <p @click="closeMenu">
                <router-link to="/industry/tielu">铁路运输</router-link>
              </p>
              <p @click="closeMenu">
                <router-link to="/industry/shuilu">水路运输</router-link>
              </p>
              <p @click="closeMenu">
                <router-link to="/industry/cangchu">仓储统配</router-link>
              </p>
              <!-- 手机端额外增加一个查看全部 -->
              <p class="mobile-only-link" @click="closeMenu">
                <router-link to="/industry">查看全部业务 ></router-link>
              </p>
            </div>
          </div>
        </li>

        <li @click="closeMenu">
          <router-link to="/newsCenter">新闻中心</router-link>
        </li>
        <li @click="closeMenu">
          <router-link to="/home#cooperation">合作伙伴</router-link>
        </li>
        <li @click="closeMenu">
          <router-link to="/about">关于我们</router-link>
        </li>
        <li @click="closeMenu">
          <router-link to="/join">加入我们</router-link>
        </li>
      </ul>
    </div>

    <!-- 手机端遮罩层：点击空白处收起菜单 -->
    <div class="nav-overlay" v-if="isMenuOpen" @click="closeMenu"></div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "HeadNav",
  components: { RouterLink },
  data() {
    return {
      isMenuOpen: false, // 控制手机端主菜单展示
      isSubMenuOpen: false, // 控制手机端“主营业务”子菜单展示
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) {
        this.isSubMenuOpen = false; // 关闭主菜单时同时重置子菜单
      }
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.isSubMenuOpen = false;
    },
    handleBusinessClick() {
      // 判断是否在移动端环境下（可以通过窗口宽度判断）
      const isMobile = window.innerWidth < 992;
      if (isMobile) {
        // 手机端：切换展开/收起状态
        this.isSubMenuOpen = !this.isSubMenuOpen;
      } else {
        // PC端：直接跳转到主页
        this.$router.push("/industry").catch(() => {});
      }
    },
  },
  watch: {
    // 监听路由，路由变化时确保菜单关闭（兜底防卡死）
    $route() {
      this.closeMenu();
    },
  },
};
</script>

<style scoped>
/* ==================== PC 端默认样式 ==================== */
.nav {
  width: 100%;
  height: 70px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #17213d; /* 建议头部给个底色，防止背景图过白时文字看不清 */
  position: relative;
  z-index: 1000;
  padding: 0 5%;
  box-sizing: border-box;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 65px;
  cursor: pointer;
  display: block;
}

.menu {
  display: block;
}

.nav_ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 0;
}

.nav_ul li {
  list-style-type: none;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  font-size: 18px; /* 原 22px 在小屏幕PC上容易挤压，18px 更安全大方 */
  margin-left: 35px;
  position: relative;
}

.menu-title {
  display: flex;
  align-items: center;
}

/* PC 端 Hover 效果保持 */
.ddd:hover .dropdown_content {
  display: block;
}

.dropdown_content {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 130px;
  background: #1f2d52;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  padding: 10px 0;
  border-radius: 4px;
  margin-top: 10px;
  z-index: 999;
}

.divsss p {
  text-align: center;
  margin: 0;
  padding: 8px 0;
}

.divsss p a {
  font-size: 15px;
  color: #e0e0e0;
  display: block;
}

.divsss p a:hover {
  color: #ffffff;
}

.mobile-toggle {
  display: none; /* PC 端隐藏汉堡按钮 */
}

.mobile-only-link {
  display: none;
}

a {
  text-decoration: none;
  color: white;
  transition: color 0.2s;
}

.router-link-active {
  color: #cbc8c8;
}

/* ==================== 📱 移动端自适应样式 ==================== */
@media screen and (max-width: 991px) {
  .nav {
    height: 60px;
    padding: 0 4%;
    position: fixed; /* 建议手机端固定顶部，用户体验更佳 */
    top: 0;
    left: 0;
  }

  .logo-img {
    height: 35px; /* 缩小手机端 Logo */
  }

  /* 汉堡按钮样式与动画 */
  .mobile-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 24px;
    height: 18px;
    cursor: pointer;
    z-index: 1001;
  }

  .mobile-toggle .line {
    width: 100%;
    height: 2px;
    background-color: #ffffff;
    transition: all 0.3s ease-in-out;
  }

  /* 汉堡按钮变成 X 的动画 */
  .mobile-toggle.is-active .line:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
  }
  .mobile-toggle.is-active .line:nth-child(2) {
    opacity: 0;
  }
  .mobile-toggle.is-active .line:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
  }

  /* 菜单改造：默认隐藏，激活时从顶部滑出/展开 */
  .menu {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    background: #17213d;
    max-height: 0; /* 用 max-height 实现平滑展开折叠效果 */
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
    z-index: 1000;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }

  .menu.mobile-show {
    max-height: 80vh; /* 展开最大高度限制 */
    overflow-y: auto; /* 允许菜单内部滚动 */
  }

  .nav_ul {
    flex-direction: column;
    align-items: stretch;
    padding: 10px 0;
  }

  .nav_ul li {
    margin-left: 0;
    text-align: left;
    padding: 15px 25px;
    border-bottom: 1px solid #233054;
    font-size: 16px; /* 调小手机端字号 */
  }

  /* 手机端下拉子菜单改造成内嵌折叠板 */
  .dropdown_content {
    display: block; /* 取消不稳定的 hover */
    position: static;
    transform: none;
    width: 100%;
    background: #10182e;
    box-shadow: none;
    border-radius: 0;
    margin-top: 10px;
    padding: 0;

    /* 默认高度为0隐藏 */
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
  }

  /* 主营业务展开状态 */
  .mobile-expanded .dropdown_content {
    max-height: 250px; /* 展开高度 */
    padding: 5px 0;
  }

  .divsss p {
    text-align: left;
    padding: 12px 20px;
    border-bottom: 1px solid #17213d;
  }

  .divsss p a {
    font-size: 15px;
    color: #b0bcdc;
  }

  .mobile-only-link a {
    color: #5375cc !important; /* 突出显示查看全部 */
  }

  /* 手机端下拉指示小箭头 */
  .arrow-icon {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 8px;
    vertical-align: middle;
    border-top: 5px solid #fff;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    transition: transform 0.3s;
  }

  .mobile-expanded .arrow-icon {
    transform: rotate(180deg); /* 展开时箭头反转 */
  }

  /* 背景遮罩 */
  .nav-overlay {
    position: fixed;
    top: 60px;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    z-index: 998;
  }
}
</style>
